/* eslint-disable no-return-assign */
import CustomFormFields from '../../auto/stores/CustomFormFields';

(() => {
  // Adicione chaves:valor com os stores que serão atribuídos ao escopo
  // global
  const store = {
    CustomFormFields,
  };
  window.store = Object.assign(window.store || {}, {});
  Object.keys(store).forEach(c => (window.store[c] = store[c]()));
})();
